var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import { FieldType } from '../../../elements';
import { rules } from '../../../helpers/Validation';
import { Form } from '../../../components';
import { t } from '../../../helpers/i18n';
var DiscountCodesForm = /** @class */ (function (_super) {
    __extends(DiscountCodesForm, _super);
    function DiscountCodesForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.TypeFixPercentage = {
            Fix: 'fix',
            Percentage: 'percentage'
        };
        _this.typeDiscountCode = Object.entries(_this.TypeFixPercentage).map(function (item) {
            return ({
                name: t("".concat(item[1])),
                value: item[1]
            });
        });
        _this.fields = [
            {
                name: 'code',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 10
            },
            {
                name: 'typeDiscount',
                type: FieldType.Select,
                rules: rules()
                    .string()
                    .required(),
                options: __spreadArray([], _this.typeDiscountCode, true),
                size: 10
            },
            {
                name: 'value',
                type: FieldType.Number,
                rules: rules()
                    .number()
                    .required(),
                size: 10
            },
            {
                name: 'start_at',
                type: FieldType.Date,
                rules: rules()
                    .date(),
                size: 10,
                value: null,
                opened: false,
                mode: 'dp-below',
                startDay: true
            },
            {
                name: 'expire_at',
                type: FieldType.Date,
                rules: rules()
                    .date(),
                size: 10,
                value: null,
                opened: false,
                mode: 'dp-below',
                endDay: true,
            },
            {
                name: 'limitUse',
                type: FieldType.Number,
                rules: rules()
                    .number(),
                size: 10
            },
        ];
        return _this;
    }
    DiscountCodesForm.prototype.render = function () {
        var discountCode = this.props.discountCode;
        var discountCodesStore = this.props.store.discountCodesStore;
        console.log('props.queryParams: ', this.props.queryParams);
        return (React.createElement(Form, { loading: ['post@discountcodes/', 'put@discountcodes/', 'patch@discountcodes/'], fields: this.fields, values: discountCode, store: discountCodesStore, stores: this.props.store }));
    };
    DiscountCodesForm = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params.id ? props.store.discountCodesStore.read(props.match.params.id).then(function (discountCode) { return ({ discountCode: discountCode }); }) : undefined
        ]; })
    ], DiscountCodesForm);
    return DiscountCodesForm;
}(Component));
export default DiscountCodesForm;



//////////////////
// WEBPACK FOOTER
// ./src/modules/DiscountCodes/containers/DiscountCodesForm.tsx
// module id = 1603
// module chunks = 0